import React from 'react';
import { ACCEPTED_FILE_MESSAGE_CLASS } from './FileInputClasses';
import translations from './translations';

const AcceptedFilesMessage = ({
  dragError,
  language = 'en',
}: {
  dragError: boolean;
  language?: 'en' | 'es';
}): JSX.Element | null => {
  if (!dragError) {
    return null;
  }
  const { invalidFileTypeLabel } = translations[language];
  return <div className={ACCEPTED_FILE_MESSAGE_CLASS}>{invalidFileTypeLabel}</div>;
};

export default AcceptedFilesMessage;
